import { type Components, alertClasses } from "@mui/material";
import { palette } from "../palette";
import { typography } from "../typography";

export const MuiAlert: Components["MuiAlert"] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: "standard", severity: "info" },
          style: {
            backgroundColor: palette.surface.main,
            [`& .${alertClasses.message}, & .${alertClasses.icon}`]: {
              color: palette.primary.main,
            },
          },
        },
        {
          props: { variant: "standard", severity: "error" },
          style: {
            backgroundColor: palette.danger.light,
            [`& .${alertClasses.message}, & .${alertClasses.icon}`]: {
              color: palette.secondary.dark,
            },
          },
        },
      ],
    },
    message: {
      ...typography.body1,
    },
    icon: {
      display: "flex",
      alignItems: "center",
      marginRight: 8,
    },
  },
};
